import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  CenteredContainer,
  Box,
  Title,
  Text,
  Button,
} from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';

import styles from './zigzag.module.less';

const ZigZag = ({
  backgroundColor,
  color,
  copyArray,
  copyLeftMobile,
  ctaText,
  ctaUrl,
  ctaPrimary,
  imageUrlDesktop,
  imageUrlMobile,
  imageAlt,
  imageFirst,
  positionImageBottom,
  title,
  titleFirst,
}) => {
  const findDefaultCenterStyle = imageFirst
    ? styles.zigZagCenteredReverse
    : styles.zigZagCentered;

  const containerColors = {
    backgroundColor: `${backgroundColor}`,
    color: `${color}`,
  };

  const findTitlePosition = positionImageBottom
    ? styles.zigZagTitleBottom
    : styles.zigZagTitle;

  const titleContentCheck =
    title && titleFirst
      ? styles.zigZagTitleFirstDesktopOnly
      : findTitlePosition;

  const renderCopy = _.map(copyArray, (copyItem, id) => {
    if (copyItem) {
      return (
        <React.Fragment>
          <div className={styles.zigZagHeader}>
            <Text size="large" key={`header-${id}`} bold>
              {copyItem.header}
            </Text>
          </div>
          <div className={styles.zigZagCopy}>
            <Text component="div">{copyItem.copy}</Text>
          </div>
        </React.Fragment>
      );
    }
    return null;
  });

  return (
    <React.Fragment>
      <div className={styles.zigZagContainer} style={containerColors}>
        <CenteredContainer>
          {title && titleFirst ? (
            <Title
              size="small"
              color={color}
              className={styles.zigZagTitleFirstMobileOnly}
              component="h2"
            >
              {title}
            </Title>
          ) : null}
          <div
            className={
              positionImageBottom
                ? styles.zigZagCenteredBottom
                : findDefaultCenterStyle
            }
          >
            <Box
              className={
                positionImageBottom
                  ? styles.zigZagContentBottom
                  : styles.zigZagContent
              }
            >
              <Box
                className={
                  copyLeftMobile
                    ? styles.zigZagTextContainerLeft
                    : styles.zigZagTextContainer
                }
              >
                {title ? (
                  <Title
                    size="small"
                    color={color}
                    className={titleContentCheck}
                    component="h2"
                  >
                    {title}
                  </Title>
                ) : null}
                {renderCopy}
                {ctaUrl ? (
                  <Button
                    className={styles.zigZagButton}
                    href={ctaUrl}
                    primary={ctaPrimary}
                  >
                    {ctaText}
                  </Button>
                ) : null}
              </Box>
            </Box>
            <div
              className={
                positionImageBottom
                  ? styles.zigZagContentBottom
                  : styles.zigZagContent
              }
            >
              <Image
                src={imageUrlMobile}
                alt={imageAlt}
                className={
                  positionImageBottom
                    ? styles.zigZagImageMobileBottom
                    : styles.zigZagImageMobile
                }
                backgroundColor="transparent"
                naturalWidth={334}
                naturalHeight={395}
                lazy
              />
              <Image
                src={imageUrlDesktop}
                alt={imageAlt}
                className={
                  positionImageBottom
                    ? styles.zigZagImageDesktopBottom
                    : styles.zigZagImageDesktop
                }
                backgroundColor="transparent"
                naturalWidth={344}
                naturalHeight={420}
                lazy
              />
            </div>
          </div>
        </CenteredContainer>
      </div>
    </React.Fragment>
  );
};

ZigZag.propTypes = {
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  copyArray: PropTypes.arrayOf(
    PropTypes.shape({ header: PropTypes.string, copy: PropTypes.string })
  ),
  copyLeftMobile: PropTypes.bool,
  ctaText: PropTypes.string,
  ctaUrl: PropTypes.string,
  ctaPrimary: PropTypes.bool,
  imageAlt: PropTypes.string,
  imageFirst: PropTypes.bool,
  imageUrlDesktop: PropTypes.string,
  imageUrlMobile: PropTypes.string,
  positionImageBottom: PropTypes.bool,
  title: PropTypes.string,
  titleFirst: PropTypes.bool,
};

ZigZag.defaultProps = {
  backgroundColor: '#ffffff',
  color: 'neutral-darkest',
  ctaPrimary: false,
  imageFirst: false,
  positionImageBottom: false,
};

ZigZag.displayName = 'Zig Zag Container';

export default ZigZag;
